// var isLive = false;
var isLive = true;
var BASE_API_URL = "";
var Rezorpay_Key = "";

if (isLive) {
  BASE_API_URL = "https://api.lifelabcare.com"; //  Live Api
  Rezorpay_Key = "rzp_live_ZaKzWhRQzr6gTK"; //  Live Key
} else {
  BASE_API_URL = "https://eLabApi.agmetech.com"; //  Local Api
  Rezorpay_Key = "rzp_test_xCsYjPoODQZka4"; //  Local Key
}

export { BASE_API_URL, Rezorpay_Key };
